var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSearchEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_2387_6586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M73.1645 0H9.85449V9.41H73.1645V0Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M73.1547 72.38H9.84473V81.79H73.1547V72.38Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.84457 9.53H0.68457V72.37H9.84457V9.53Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.175 23.41H22.835V32.75H32.175V23.41Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8242 63.0303H60.1642V53.6903H50.835V44.3602H41.495H32.165V53.6805H22.835V63.0205H32.175V53.7002H41.495H50.8242V63.0303Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M60.1642 23.41H50.8242V32.75H60.1642V23.41Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M82.3143 9.41H73.1543V72.38H82.3143V9.41Z",
    fill: "white",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2387_6586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.63,
    height: 81.79,
    fill: "white",
    transform: "translate(0.68457)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchEmpty);
export default __webpack_public_path__ + "static/media/icon-search-empty.a3891b376bcf79380b00601723333ffc.svg";
export { ForwardRef as ReactComponent };